/* eslint-disable quotes */
// Polonês
export const polones = {
  start: "Rozpocznij",
  configurations: "Ustawienia",
  ramdom: "Tryb gry losowej",
  vibration: "Wibracje :",
  startgame: "Rozpocznij grę",
  save: "Zapisz",
  delete: "Usuń",
  update: "Aktualizacja",
  lets: "Zagrajmy",
  permanentbuy: "Zakupy stałe",
  signature: "Abonament miesięczny",
  signatureano: "Abonament roczny",
  small: "Tutaj możesz użyć swojego prawdziwego nazwiska... lub pseudonimu. :)",
  text1: "Uzyskaj dostęp premium i zagwarantuj sobie wszystkie aktualizacje",
  text2:
    "Dzięki subskrypcji możesz mieć dostęp do wersji Premium kiedy tylko chcesz",
  gender: "Płeć",
  male: "Męski  ",
  female: "Kobieta",
  ambos: "Zarówno",
  fechar: "Blisko",
  sexualorientation: "Orientacja seksualna",
  heterosexual: "Heteroseksualny",
  homosexual: "Homoseksualista",
  bisexual: "Biseksualny",
  chooseavatar: "Wybierz swój awatar",
  Participants: "Uczestnicy",
  participant: "Rejestracja uczestników",
  name: "Nazwa",
  choosecategory: "Wybierz kategorie",
  categories: "Kategorie",
  light: "Światło",
  preliminary: "Wstępny",
  oral: "Seks oralny",
  anal: "Seks analny",
  hot: "Gorąca",
  extreme: "Ekstremalne",
  vd: "Prawda ?",
  dare: "Wyzwania ?",
  truth: "Prawda",
  time: "Czas",
  createMyChallenges: "Stwórz moje wyzwania",
  chosen: "Wybrane",
  text3: "Niech miłość płynie w tobie!",
  text4: "Przygotuj się na intensywne życie",
  close: "Zamknij",
  sele: "Wybierz opcję",
  dev: "Opracowany przez Dev12BR",
  game: "Gra",
  get: "Comprar - R$ 34,99",
  sign: "Assinar - R$ 5,99",
  next: "DALEJ",
  config1: "Dlaczego powinienem kupić wersję Premium ?",
  config2: "Ekskluzywne kategorie i ponad 800 nowych wyzwań",
  config3: "Brak reklam",
  config4: "Wybierz awatary, aby zwiększyć",
  config5: "Stwórz swoje własne wyzwania ",
  config6: "Wspierasz rozwój gier",
  config7: "Dlaczego gra ma swój koszt?",
  config8:
    "Aby rozwijać grę potrzebny jest czas! :) W ten sposób wspierasz grę, pomagasz nam zawsze ulepszać i aktualizować grę.",
  config9: "Twórz i edytuj własne wyzwania.",
  age: `Ta gra jest przeznaczona tylko dla dorosłych, więc musisz mieć co najmniej 18 lat. Wybierając "Tak", zgadzasz się na warunki użytkowania i politykę prywatności.. 

    Ta gra jest odpowiednia dla par, więc należy grać z co najmniej jednym partnerem.
    
    To nie jest aplikacja randkowa, ale sposób na zabawę z partnerem.
    `,
  config10: "Ekskluzywne kategorie",
  config11: "+ 800 nowych wyzwań",
  assessment:
    "Oceń to, dodając komentarz o aplikacji. Twoja opinia jest dla nas bardzo ważna, aby utrzymać grę tak dobrą, jak to tylko możliwe.",
  agree: "Tak, mam ukończone 18 lat",
  noAgree: "Zamknięcie aplikacji",
  apoio1: "Wspieraj rozwój poprzez subskrypcję wersji Premium :)",
  apoio2: "Nie zapomnij ocenić aplikacji w sklepie  S2",
  apoio3: "Uzyskaj dostęp do wszystkich ekskluzywnych funkcji w wersji Premium",
  apoio4: "Pozbądź się tego banera - kup wersję Premium",
  version: "Wersja Premium",
  version1: "Wersja Premium",
  alert1: "Rejestracja użytkowników do gry",
  alert2: "Zarejestruj przynajmniej jeszcze jednego użytkownika do gry",
  alert3: "Wybierz co najmniej jedną kategorię",
  alert4: `🔥 Są uczestnicy bez partnerów. Miej co najmniej dwóch uczestników dla każdej płci 🔞. 
        
Przykład: dwóch heteroseksualistów lub dwóch homoseksualistów`,
  tituloAlert1: "⚠️ Gra zaraz się zacznie 😜",
  tituloAlert2:
    "⚠️ Szkoda 😬, Jesteście bez internetu 📶. Włącz internet na swoim urządzeniu i wykup abonament, czyli plan ultimate. And be happy😘",
  parser: "Nie ma partnera",
  premiumImages: "Zostań Premium i uzyskaj dostęp do większej ilości awatarów",
  duvidas: "Pytania lub sugestie - Pikantne wyzwania",
  description: "Witam, moje pytanie lub sugestia jest taka :",
  texto99:
    "Jeśli masz jakiekolwiek problemy, pytania lub sugestie, prosimy o wysłanie do nas wiadomości e-mail, klikając ten przycisk poniżej. Czekamy na rozmowę z Tobą!",
  send: "Wyślij",
  contact: "Kontakt",
  botaoApple: "Przywrócenie zakupów",
  alertCompra: "Twój zakup jest przywracany.",
  NotPurchase: "Nie masz żadnych zakupów",
  notPurchase2:
    "To łącze jest przeznaczone tylko dla użytkowników, którzy dokonali poprzednich zakupów i chcą przywrócić je na nowe urządzenie.",
  termOfPotitic: "Warunki użytkowania i polityka prywatności",
  alertDeuErrado: "Coś poszło nie tak :(",
  alertDeuErrado2: "Wypełnij wszystkie informacje",
  alertNome: "Wypełnij pole: Nazwa",
  options: "Opcje",
  optionsTitle: "Opcje",
  gradualGame: "Gra stopniowa",
  textoCaixa:
    "Aktywując ten wybór, wyzwania będą stopniowane, tzn. od najlżejszych do najbardziej ekstremalnych zgodnie z Twoim wyborem.",
  comoJogar: "Jak grać? 🤔",
  avalie: "Oceń",
  novaCategoria: "Moje kategorie",
  alterLanguage: "Zmienić język? ?",
  textLanguage: "Przy zmianie języka aplikacja zostanie zrestartowana",
  textLanguage1: "Zmiana języka ",
  cancel: "Anuluj",
  languages: "Języki",
  email: "@email ✉️",
  deletCat: "Usunąć kategorię",
  textDeletCat:
    "Usuwając tę kategorię, wyzwania w niej zawarte zostaną usunięte. Po tej akcji nie można już jej cofnąć.",
  deletDes: "Usuń wyzwanie",
  textDeletDes: "Po usunięciu wyzwania nie można już cofnąć tej czynności.",
  desafio: "Zarejestruj nowe wyzwanie",
  desafiotexto: "Wyzwanie",
  textoeditDesafio: "Kto może to zrobić?",
  textEmquem: "Na kim?",
  nome: "Nazwa",
  inicio: "Rozpoczęcie gry",
  inicio2:
    "Po naciśnięciu tego przycisku zostaniesz przeniesiony do ekranu rejestracji gracza 👥.",
  inicio3: "Gra zaraz się zacznie 🎲",
  inicio4: "Następny",
  inicio5: "Regulacje i ustawienia",
  inicio6: `Korekty takie jak: 
  
- Postępowe wyzwania
- Zmień język wyzwań 
- Stwórz wyzwania 
- wspieranie 
- Między innymi.`,
  inicio7: "Koniec",
  inicio8: `Zostań Premium i uzyskaj dostęp do:

- 450 więcej nowych wyzwań 😎

- Znaki wyłączne 🦸♀️ 🧑🚒
  
- Stwórz swoje własne wyzwania 📝
  
- Niech gra będzie aktualizowana ✅
  
- I wiele więcej 😍`,
  inicio9: "Pomoc",
  inicio10: 'Witamy w grze "Pikantne wyzwania 🌶',
  inicio11:
    "Zobacz, jak łatwo jest grać i poruszać się po menu w mniej niż 30 sekund. 😎.",
  inicio12: "Zobacz samouczek 👍🏼",
  inicio13: "Nie chcę 👎🏼",
  inicio14: `Aby rozpocząć grę, musisz dodać co najmniej (2) dwóch graczy 😀
              
Wciśnięcie przycisku wskazanego powyżej 👆
  
Za każdym razem, gdy dodajesz nowego użytkownika, naciśnij ten sam przycisk😘`,
  cadastrarCategory: "Kategoria rejestracji",
  inicio15: "Tworzenie nowej kategorii",
  inicio16:
    "Krok 1 : Naciśnij przycisk ze znakiem +, który znajduje się na dole tego ekranu. Po naciśnięciu pojawi się okno, w którym należy wprowadzić nową kategorię.",
  inicio17: "Krok 2: Wprowadź nową kategorię i kliknij przycisk Zapisz",
  inicio18:
    "Krok 3: Aby edytować tę kategorię lub DODAĆ wyzwania w ramach kategorii, kliknij na nią.",
  inicio19:
    "Krok 4: Na kolejnym ekranie naciśnięcie przycisku oznaczonego strzałką ⬆️ otworzy okno edycji Twojej nowej kategorii.",
  inicio20:
    "Krok 5: Na następnym ekranie, naciskając przycisk wskazany strzałką ⬆️, usuniesz kategorię.",
  inicio21:
    "Krok 1: Naciśnij przycisk poniżej, aby dodać nowe wyzwanie do tej kategorii",
  inicio22: "Tworzenie nowego wyzwania",
  inicio23:
    "Krok 2: Kliknij na każdą zakreśloną pozycję, aby poznać szczegółowo każde pole rejestru",
  inicio24: "Tekst wyzwania",
  inicio25: `Napisz wyzwanie według własnego uznania, a żeby w wyzwaniu pojawiło się nazwisko gracza, wystarczy nacisnąć czerwony przycisk poniżej. 
    
Doda on następujące znaki {nome}. 

** NIE ZMIENIAJ TYCH ZNAKÓW ** Ponieważ aby nazwa była odpowiednio wyświetlana, musi być taka, jak opisano poniżej ⬇️⬇️⬇️⬇️.

Wyzwanie: Pocałuj w szyję {nome}`,
  inicio26: "Kto może robić, a kto może otrzymywać",
  inicio27: `Wybierz "Obie", jeśli wyzwanie może być wykonane i odebrane przez uczestników "obu" płci..
  
Jeśli wyzwanie jest skierowane do jakiegoś gatunku, po prostu wybierz pożądany.
`,
  inicio28: "Dodanie czasu do wyzwania",
  inicio29:
    'Jeśli Twoje wyzwanie ma czas, po prostu przeciągnij "zakres" poniżej, a wartość zostanie wyświetlona powyżej. Po upływie czasu przeznaczonego na wykonanie wyzwania, zostanie odtworzony dźwięk informujący o zakończeniu wyzwania.',
  aviso12: `Tutaj tworzysz tylko kategorię!
    
Aby dodać wyzwania wystarczy nacisnąć przycisk swojej kategorii, która właśnie została utworzona ⬆️⬆️⬆️⬆️⬆️.`,
  voltar: "Powrót",
  semDe: "Gracz bez wyzwania",
  semDe2: `Zarejestruj co najmniej jedno wyzwanie dla tego gracza 😬. 
  
Zostaniesz przekierowany do ekranu logowania.`,
  term: "Prywatność",
  Potitic: "Warunki użytkowania",
  adquirited: "Pozyskane",
  camera: "Kamera",
  galery: "Galeria zdjęć",
  avatar: "Avatar",
  image: "Zdjęcie",
  seletion: " Wybrane",
  editCategory: "Edytuj kategorię",
  frase1: "Czy cieszą cię te wyzwania?",
  frase2: "Co powiesz na wypróbowanie Wyzwań Premium?",
  //err texto

  errTexto: "Jeśli znalazłeś błąd w tłumaczeniu, popraw zdanie w polu poniżej:",
  errTitulo: "Zauważyłeś coś nieprawidłowego?",
  errCorrect: "Jak powinno to brzmieć po polsku?",
  thisLanguageIsCorrect: "Czy wyzwanie po POLSKU jest poprawne?",
  yes: "Tak",
  no: "Nie",
  errSend: "Wyślij sugestię",
  share: "Udostępnij",
  fraseShare: `Co za Top app! Po prostu dzielę się, bo wiem, że Tobie też się spodoba!🫣
  Pobierz i potem powiedz czy nie jest za dobra lol...😉
  
  
  Link do pobrania: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇵🇱",
  morePlayer: "Grać z większą ilością graczy ?",
  players: "Gracze",
  carregar: "Prześlij obraz",
  takePhoto: "Zrób zdjęcie lub wybierz obraz",
  useAvatar: "Albo użyj awatarów",

  hetero: "Para heteroseksualistów",
  gay: "Para gejów",
  lesbico: "Lesbijka",

  nomeHomem1: "James",
  nomeHomem2: "George",
  nomeMulher1: "Emily",
  nomeMulher2: "Mia",
  messageErr: "Dodaj zawodników 🙌",
  descricaoErr: "Wpisz nazwiska uczestników ✍️",
  why: "Powiedz nam dlaczego...",
  later: "Ocenić później",
  txtCard1: "Twoja kolej 🔥",
  txtCard2: "Zrób to 😘",
  txtCard3: "Dalej! 😜",
  txtCard4: "Następne wyzwanie 😈",
  txtCard5: "Jeszcze jedno! 👄",

  tituloBloco1Novo: "Poznaj intymność seksualną ze swoim partnerem",
  subtitulo1Novo: "Ponad 1 milion szczęśliwych par",
  texto1Novo:
    "Odkryj intymność między tobą a twoim partnerem i uzyskaj dostęp do najlepszych gier dla par! Odblokuj teraz wszystkie gry z kilku kategorii przeznaczonych dla Was, aby poprawić połączenie z Waszą miłością!",

  tituloBloco2Novo: "Nowe doświadczenia i lepszy związek",
  texto2Novo1: "Ciesz się ponad 1500 wyzwaniami",
  texto2Novo2: "Twórz własne wyzwania",
  texto2Novo3: "Ekskluzywne kategorie",
  texto2Novo4: "Bez reklam",
  texto2Novo5: "Ekskluzywne awatary",
  texto2Novo6: "Codziennie nowe wyzwania ",
  texto2Novo7: "Regularnie aktualizowane gry.",
  tituloBloco3Novo: "Najwyższa ocena w kategorii",
  tituloBloco4Novo: "Korzyści dla twojego związku:",
  texto4Novo1: "Intymne",
  texto4Novo2: "Pożądanie",
  texto4Novo3: "Lekkie",
  texto4Novo4: "Przyciągające",
  texto4Novo5: "Połączliwe",
  texto4Novo6: "Przyjemne",

  tituloBloco5Novo: "Co mówią pary",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Uważam, że to najlepsza aplikacja, jaką do tej pory znalazłem na telefonie. Jest erotyczna i interesująca, a wszystkie inne aplikacje, które widziałem, nie mogą się z nią równać. Znajdź pracę i ją kup. Nie narzekaj, że nie masz pieniędzy. Omija cię coś naprawdę wyjątkowego, a za jedyne 10 dolarów możesz mieć całą aplikację. Oferuje lepsze doświadczenia niż gry, które można znaleźć w lokalnych sklepach z akcesoriami erotycznymi.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Ta aplikacja jest niesamowita! Miałem wątpliwości, czy ją pobrać, ale to zdecydowanie najlepsze uczucie, jakie mieliśmy od dawna. Jak dobrze wiedzieć, że wciąż możemy robić razem tak wiele rzeczy. 🤭 Przetestowaliśmy płatną wersję i naprawdę warto - nigdy wcześniej nie osiągnęliśmy takiego poziomu przyjemności.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Jeśli chcesz ożywić swój związek, ta aplikacja jest idealna! Testowałam już inne, ale żadna nie podobała nam się tak jak ta. Nasza gra wstępna była o wiele gorętsza i przyjemniejsza (wyobraź sobie resztę!). Naprawdę warto kupić płatną wersję (jeśli chcesz doświadczyć bardziej intensywnej przyjemności), ale darmowa wersja również pozytywnie zaskakuje.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "Doskonale! Naprawdę świetna... Podczas gry byliśmy bardzo podnieceni, co sprawiło, że seks był znacznie bardziej ekscytujący – przyjemność była wszędzie! Już nie możemy się doczekać, żeby zagrać ponownie 💦🔥. Polecamy także płatną wersję, jeśli jesteście w stanie poradzić sobie z takim podnieceniem 🤤.",
  tituloBloco6Novo:
    "Czy jak setki par na całym świecie i urozmaić swój związek. Odkryj ponad 800 nowych wyzwań!",
  texto6Select: "Wybierz wersję:",
  texto6Premium: "Premium",
  texto6Assinatura: "subskrypcja ",
  texto6Mensal: "abonament miesięczny",
  texto6Anual: "roczna prenumerata ",
  texto6Vitalicia: "licencja wieczysta",
  bePremium: "Dołącz do premium",
  buyNew: "Kup",
  attention: "Uwaga!!!",
  changeGender: "Zmieniłeś swoją orientację seksualną",

  tituloAvaliacao: "Lubisz grę?",
  textoAvaliacao: "Oceń i pomóż nam nadal się rozwijać!",
  agoraNão: "Nie teraz",
  enviarAvaliacao: "Wyślij",

  nomeJogo1: "Pikantne Wyzwania",
  nomeJogo2: "Prawda czy Wyzwanie?",
  nomeJogo3: "Poziom Zmysłowości",
  nomeJogo4: "Niegrzeczna Ruletka",
  nomeJogo5: "Cytat dnia",
  naughtyQuiz: "Łobuzerski Quiz",

  playAlone: "Zagraj sam",
  estaSozinho: "Jesteś sam?",
  selectPlayer: "Wybierz gracza",

  skip: "Pomiń",
  responder: "Wyślij",
  respondaAqui: "Odpowiedz tutaj",
  config4: "Επιλέξτε χαρακτήρες για εξατομίκευση",

  tituloSelect1: "Zagraj sam",
  tituloSelect2: "Odpowiadaj na krępujące pytania!",

  subTituloSelect1: "Pomagamy ci!",
  subTituloSelect2: "Odkryj, jak niegrzeczny jesteś!",
  txtJogador1:
    "Wybierz swojego gracza i odkrywaj prowadzone przyjemności solo stworzone specjalnie dla ciebie!",
  txtJogador2: "Wybrany gracz odpowiada na pytania",
  tituloCena: "JAKIE ELEMENTY CHCESZ UŻYĆ?",
  subTituloCena:
    "Nie masz jednego? Dotknij przycisku „Pobierz” i odbierz go w sklepie partnerskim.",
  play: "Zagraj",

  titleUserWarning: "Wybierz użytkownika",
  txtUserWarning: "Wybierz użytkownika, aby odpowiedzieć na pytania",
  shareNivelDeSafadeza:
    "Hej, sprawdź mój poziom niegrzeczności 😈 Doświadcz intensywnych chwil przyjemności. Ty też 💋 Pobierz teraz aplikację i przygotuj się do gorących wyzwań 🔥 ze swoim partnerem: ➡️ https://aplikacjawyzywaniepage.link/sharelevelhot",

  shareDica:
    "Zmień teraz swoje życie miłosne! Pobierz aplikację i odkryj sekret pikantnego związku: ➡️ https://aplikacjawyzywanie.page.link/tipoftheday",

  resultadoQuiz1:
    "Jesteś osobą skromną, nie przepadasz zbytnio za figlarnością, wolisz coś bardziej romantycznego!",
  resultadoQuiz2:
    "Jesteś zbyt romantyczny, aby nadmiernie eksperymentować z figlarnościami, preferujesz atmosferę przy świecach.",
  resultadoQuiz3:
    "Jesteś dosyć powściągliwą osobą i wierzysz w zachowywanie intymnych spraw w dyskrecji i prywatności.",
  resultadoQuiz4:
    "To nie oznacza, że nie potrafisz być figlarny/cię czasem, ale wolisz zachować cały ten ogień na kogoś naprawdę wyjątkowego.",
  resultadoQuiz5:
    "Twoje gorące emocje są na drugim planie, ale to nie zmienia faktu, że są obecne!",
  resultadoQuiz6:
    "Lubiysz eksplorować nowe doświadczenia, zawsze jednak z szacunkiem i zgodą.",
  resultadoQuiz7:
    "Uwielbiasz gorące randki pełne pocałunków i zabawy. Jednak istnieje w Tobie także strona, która lubi obejrzeć film, trzymając się za ręce z ukochaną osobą lub zjeść kolację przy świecach.",
  resultadoQuiz8:
    "Jesteś gotowy/a na wypróbowywanie nowych, ekscytujących rzeczy, zawsze jednak z odpowiedzialnością.",
  resultadoQuiz9:
    "Jesteś odważną osobą i lubisz od czasu do czasu dodać pikanterii do swojego życia intymnego.",
  resultadoQuiz10:
    "Cieszysz się życiem i nie znosisz ograniczeń, jeśli chodzi o seks.",
  resultadoQuiz11:
    'Z Tobą nie ma złego czasu, zawsze jest okazja na szybkie uniesienie! Film romantyczny? Tylko jeśli to "Pięćdziesiąt twarzy Greya"!',
  resultadoQuiz12:
    "Dla Ciebie intymność to ciągła przygoda, nie boisz się podejmować ryzyka.",

  mes: "Miesiąc",
  desafiosRestantesDois: "Masz jeszcze 2 Premiumowe wyzwania!",
  nenhumDesafioRestante: "Brak Premiumowych wyzwań!",
  tornePremiumAviso1:
    "Zostań teraz użytkownikiem premium i skorzystaj z 1000 wyzwań Ekskluzywnych!",
  tornePremiumAviso2:
    "Ciesz się nieograniczonymi wyzwaniami, ekskluzywnymi treściami i nieprzerwaną zabawą!",
  conteudoPremium: "Wybrałeś treść Premium!",
  aproveite4desafios:
    "Skorzystaj z 4 Premiumowych wyzwań, aby doświadczyć ekskluzywnej przyjemności.",
  calculando: "Obliczanie wyników...",
  nivelRomantismo: "Twój poziom romantyzmu to...",
  finalizar: "Zakończ",
  erroQuizTitulo: "Wprowadź swoją odpowiedź",
  erroQuizFrase: "Aby kontynuować, wprowadź swoją odpowiedź!",
  new: "Nowa Aplikacja",

  //resposta quiz safadeza

  resQuiz1: "Łagodny",
  resQuiz2: "Namiętny",
  resQuiz3: "Uroczy",
  resQuiz4: "Super niegrzeczny",

  texto6Semanal: "Tygodniowo",
  weekly: "Tygodniowy Podpis",

  tempSemanal: "Rozliczane co tydzień",
  tempMensal: "Rozliczane co miesiąc",
  tempAnual: "Rozliczane co rok",
  tempSempre: "Jednorazowa płatność",
  canceleAny: "Anuluj w dowolnym momencie",

  //Tela do safadrometro
  Low: "Niski",
  Medium: "Średni",
  High: "Wysoki",
  lifeTime: "Dostęp do życia",
  notNow: "Nie teraz, dziękuję",
  match: "DOBIERZ SIĘ Z A.I.",

  //Modal date
  dateTitle: "Chcesz zobaczyć naszą nową aplikację?",

  dateBody: `Chcesz porozmawiać z niegrzecznymi 😈 botami i poćwiczyć flirtowanie? Będzie świetna zabawa!🔥`,
  goToDate: "Wypróbuj Date.AI już teraz!",

  goodForU: "CZY BYŁO DOBRZE DLA CIEBIE?",
  rateOurPerformance: "Oceń naszą wydajność do tej pory",
  veryGood: "Bardzo Dobrze",
  veryBad: "Bardzo Źle",
  feedbackChallenge: `Co sprawiłoby, że podzieliłbyś się aplikacją Hot Challenges z innymi parami i dlaczego?`,
  type: "Wpisz swoją odpowiedź tutaj...",
  survey: "Ankieta satysfakcji.",
  shareIfConfortable: `Czuj się swobodnie, aby podzielić się z przyjaciółmi, jeśli czujesz się z tym komfortowo :)`,

  howToPlay: "Jak grać",
  howToPlayHotChallenge:
    "Przygotuj się na podkręcenie atmosfery! Wylosuj kartę wyzwania i zaskocz swojego partnera gorącą akcją!",

  preGameTip1:
    "Uwolnij swoje pragnienia i stwórz niezapomniane chwile z partnerem!",
  preGameTip2: "Rozpal swoje namiętności i stwórz niezapomniane chwile razem!",
  preGameTip3:
    "Odkryj swoje najdziksze pragnienia i stwórz niezapomniane wspomnienia!",
  preGameTip4:
    "Uwolnij swoje fantazje i rozkoszuj się chwilami czystej przyjemności!",
  selecionajoagador: "Czas na grę",
  dica: "Wskazówka",
  howToPlayNaughty:
    "Wybierz swoje ulubione zabawki i przedmioty. Zakręć kołem i pozwól, aby los zdecydował o twoim następnym niegrzecznym wyzwaniu!",
  howToPlayTruthOrDare:
    "Wybierz swój los: podziel się prawdą lub podejmij śmiałe wyzwanie. Niech zabawa się zacznie!",

  howToKama1: "Odkryj Pozycje Przyjemności – 365 Dni Pasji!",
  howToKama2:
    "Wybierz losową kartę, spróbuj pozycji i razem odkrywajcie nowe szczyty rozkoszy!",
  kamaExplain:
    "Odblokuj nową pozycję każdego dnia i zbuduj swoją ostateczną kolekcję pasji – twoja podróż przez 365 dni niezapomnianej rozkoszy zaczyna się tutaj!",
  howToDo: "Jak to zrobić",
  pergunta: "Pytanie",
  restart: "Uruchom ponownie",
  dialogText1HotChallenges:
    "Ukończyłeś wszystkie dostępne wyzwania w wybranych kategoriach.",
  dialogText2HotChallenges:
    "Wybierz więcej kategorii lub uruchom grę ponownie z aktualnymi wyzwaniami!",
  noChallenges: "Brak wyzwań!",

  objects: "Obiekty",
  dialogText1NaughtyGames:
    "Ukończyłeś wszystkie dostępne wyzwania z wybranymi obiektami.",
  dialogText2NaughtyGames:
    "Wybierz więcej obiektów lub zacznij grę od nowa z obecnymi wyzwaniami!",
  unlockPremium: "Odblokuj Premium",
  noCategory: "Wybierz przynajmniej jedną kategorię, aby rozpocząć.",
  thanksForFeedback: "Dziękujemy za pomoc w ulepszaniu doświadczenia!",
  categoryKamasutra: "Wybierz swoją pasję i graj!",
  tap: "Stuknij, aby odkryć swoją pozycję!",
  step: "Przewodnik Krok po Kroku",
  shareQuizButton: "Podziel się swoim poziomem niegrzeczności!",
  tryAgain: "Spróbuj ponownie",
  unlockAllFun: "Odblokuj całą zabawę",
  limitedOffer: "Oferta specjalna na ograniczony czas!",
  fill: "Wpisz swoje imię oraz imię partnera lub partnerki.",

  kamaNotificationTitle: "🔥 Twoja nowa karta została odblokowana!",
  kamaNotificationBody:
    "Twoja pozycja na dzień {variavel} jest gotowa. Może spróbujesz dziś czegoś nowego? 💋",

  titleNewGame: "Przygotuj się na Roleplay!",
  phraseNewGame:
    "W nadchodzącej aktualizacji pojawi się nowa gra, która pozwoli ci odkryć najbardziej kreatywne fantazje. Wybierz postacie, stwórz historie i podnieś poziom zabawy ze swoim partnerem. 🔥",
  awaitNewGame: "Czekaj i przygotuj się na wyjątkowe chwile!",

  selectObjects:
    "Wybierz dwa lub więcej przedmiotów, aby dostosować swoją grę. Eksploruj na maksa.",
  soon: "Wkrótce",
  wantToBeNotify: "Chcę być powiadomiony.",
  ok: "OK",
  vezDe: "SKRĘT",

  categoryLabel: "Kategoria",
  descriptionLabel: "Opis",

  loginConnect: "Zaloguj się",
  loginNoAccount: "Nie masz konta?",
  loginCreateNow: "Utwórz teraz",
  loginOrConnect: "lub zaloguj się za pomocą",

  email: "Email",
  password: "Hasło",
  loginRegister: "Zarejestruj się",
  loginAlreadyHas: "Masz już konto?",
  enterNow: "Zaloguj się teraz",

  logout: "Wyloguj się",
  customerPortal: "Portal Klienta",
  installApp: "Zainstaluj aplikację",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/polones.mp4",
};
